import './consentManager';

import './carousel';

import '../components/accordion/accordion';
import '../components/alert/alert';
import '../components/backdrop/backdrop';
import '../components/custom-form/custom-form';
import '../components/feedback/feedback';
import '../components/footer/footer';
import '../components/gallery/gallery';
import '../components/header/header';
import '../components/iframe/iframe';
import '../components/map/map';
import '../components/menu-large/menu-large';
import '../components/menu-small/menu-small';
import '../components/modal/modal';
import '../components/search-facet-date/search-facet-date';
import '../components/search-facet-select/search-facet-select';
import '../components/search-keyword/search-keyword';
import '../components/table-of-content/table-of-content';
import '../components/video/video';
